import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import GetBestWorstTopPlans from "../../api/performance/GetBestWorstTopPlans";
import { getPluralString } from "../../helpers/wordHelpers";
import { Avatar, Popover, Progress, Tag } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { SimpleLoader } from "../sub/Loaders";
import moment from "moment";
import { getTargetString } from "../../helpers/targetHelpers";
import { ArrowRightOutlined } from "@ant-design/icons";

function BestWorstTopPlans() {
  const [bestTopPlans, setBestTopPlans] = useState([]);
  const [worstTopPlans, setWorstTopPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const topPlanState = useSelector((state) => state.topPlanState.value);
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const positionState = useSelector((state) => state.positionState.value);
  let navigate = useNavigate();

  useEffect(() => {
    getBestWorstPlans();
  }, [perfCycleState]);

  async function getBestWorstPlans() {
    setLoading(true);
    const apiResponse = await GetBestWorstTopPlans(
      positionState?.id,
      perfCycleState?.id
    );
    if (apiResponse.success) {
      setBestTopPlans(apiResponse?.data?.bestTopPlans);
      setWorstTopPlans(apiResponse?.data?.worstTopPlans);
      setLoading(false);
    }
  }

  function getBestGraph() {
    let output = [];

    bestTopPlans.forEach((plan) => {
      output.push(
        <div
          className="border rounded "
          style={{
            borderColor: "#e5e7eb",
          }}
        >
          <div className="flex">
            <div className="w-full p-4">
              <div className="flex justify-between w-full items-center">
                <div>
                  <div className="flex items-center mb-1">
                    <Tag>{plan?.planGroup}</Tag>
                    <div className="text-xs text-gray-400">
                      {plan?.targetDate
                        ? moment(plan?.targetDate).format("DD.MM.YYYY")
                        : ""}
                    </div>
                  </div>
                  {plan?.title +
                    " - " +
                    getTargetString(
                      plan?.target,
                      plan?.scale?.scaleName,
                      plan?.scale?.scaleUnitAbbreviation
                    )}
                </div>
                <div className="">
                  <Popover
                    placement="left"
                    content={
                      <div>
                        {plan?.assignedTo?.firstName +
                          " " +
                          plan?.assignedTo?.lastName}
                      </div>
                    }
                    trigger="hover"
                  >
                    {plan?.assignedTo?.imageUrl ? (
                      <Avatar
                        className="cursor-pointer"
                        src={plan?.assignedTo?.imageUrl}
                      />
                    ) : (
                      <Avatar>
                        {plan?.assignedTo?.firstName?.charAt(0).toUpperCase()}
                      </Avatar>
                    )}
                  </Popover>
                </div>
              </div>
              <Progress
                strokeColor={{
                  "0%": "#108ee9",
                  "100%": "#87d068",
                }}
                percent={plan?.performance || 0}
                strokeLinecap="square"
                size="large"
                showInfo={false}
              />
            </div>
            <Link to={`/top-plans/${plan.id}`}>
              <div className="flex justify-center items-center p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer h-full">
                <ArrowRightOutlined />
              </div>
            </Link>
          </div>
        </div>
      );
    });

    return output;
  }

  function getWorstGraph() {
    let output = [];

    worstTopPlans.forEach((plan) => {
      output.push(
        <div
          className="border rounded"
          style={{
            borderColor: "#e5e7eb",
          }}
        >
          <div className="flex">
            <div className="w-full p-4">
              <div className="flex justify-between w-full items-center">
                <div>
                  <div className="flex items-center mb-1">
                    <Tag>{plan?.planGroup}</Tag>
                    <div className="text-xs text-gray-400">
                      {plan?.targetDate
                        ? moment(plan?.targetDate).format("DD.MM.YYYY")
                        : ""}
                    </div>
                  </div>
                  {plan?.title +
                    " - " +
                    getTargetString(
                      plan?.target,
                      plan?.scale?.scaleName,
                      plan?.scale?.scaleUnitAbbreviation
                    )}
                </div>
                <div className="">
                  <Popover
                    placement="left"
                    content={
                      <div>
                        {plan?.assignedTo?.firstName +
                          " " +
                          plan?.assignedTo?.lastName}
                      </div>
                    }
                    trigger="hover"
                  >
                    {plan?.assignedTo?.imageUrl ? (
                      <Avatar
                        className="cursor-pointer"
                        src={plan?.assignedTo?.imageUrl}
                      />
                    ) : (
                      <Avatar>
                        {plan?.assignedTo?.firstName?.charAt(0).toUpperCase()}
                      </Avatar>
                    )}
                  </Popover>
                </div>
              </div>
              <Progress
                strokeColor={{
                  "0%": "#108ee9",
                  "100%": "#87d068",
                }}
                percent={plan?.performance || 0}
                strokeLinecap="square"
                size="large"
                showInfo={false}
              />
            </div>
            <Link to={`/top-plans/${plan.id}`}>
              <div className="flex justify-center items-center p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer h-full">
                <ArrowRightOutlined />
              </div>
            </Link>
          </div>
        </div>
      );
    });

    return output;
  }

  return (
    <>
      <div className="grid grid-cols-2 gap-5 mb-10">
        {loading ? (
          <SimpleLoader />
        ) : (
          <div className="border p-5 rounded-md">
            <div className="flex items-center justify-between text-base mb-2">
              <div>
                Best Performing {getPluralString(topPlanState) || "Top plans"}{" "}
              </div>
            </div>

            <div className="grid gap-3">{getBestGraph()}</div>
          </div>
        )}
        {loading ? (
          <SimpleLoader />
        ) : (
          <div className="border p-5 rounded-md ">
            <div className="flex items-center justify-between text-base mb-2">
              <div>
                Worst Performing {getPluralString(topPlanState) || "Top plans"}{" "}
              </div>
            </div>
            <div className="grid gap-3"> {getWorstGraph()}</div>
          </div>
        )}
      </div>
    </>
  );
}

export default BestWorstTopPlans;
